import React, { useState } from 'react'
import Button from 'components/Button'
import Condition from 'components/Condition'
import ProjectSubmissionDialog from 'components/CodeTestBrowser/ProjectSubmissionDialog'

export interface ICodeTestBrowserProps {
  disabled?: boolean
}

export interface ICodeTestBrowserState {
  isDialogOpen: boolean
  isSubmissionDialogOpen: boolean
  selectedCodeTestId: string
}

function CodeTestBrowser({ disabled }: ICodeTestBrowserProps) {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  return (
    <React.Fragment>
      <Button onClick={() => setIsDialogOpen(true)} disabled={disabled} data-cy="add-sample-work">
        Add sample work
      </Button>
      <Condition condition={isDialogOpen}>
        <ProjectSubmissionDialog onClose={() => setIsDialogOpen(false)} />
      </Condition>
    </React.Fragment>
  )
}

export default React.memo(CodeTestBrowser)
